import { get } from 'lodash'

export default function () {
  /** Unidade Selecionada */
  if (get(this.$route, 'params.tower_id', null) !== null) {
    this.selectUnitsTower(get(this.$route, 'params.tower_id', null))
  }
  /** Garagens */
  if (get(this.$route, 'params.unit_id', null) !== null) {
    this.getGaragesDwellerEdit(get(this.$route, 'params.unit_id', null), get(this.$route, 'params.tower_id', null))
  }
  this.getTowersDweller()
}



// WEBPACK FOOTER //
// ./src/app/dweller/bike/form/resources/mounted.js